import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { ProspectListParams } from '../types';

export function useProspects(params?: ProspectListParams) {
  return useQuery({
    queryKey: ['prospects', params],
    queryFn: () => api.listProspects(params),
    staleTime: 30_000,
  });
}

export function useProspect(id: string | null) {
  return useQuery({
    queryKey: ['prospect', id],
    queryFn: () => api.getProspect(id!),
    enabled: !!id,
    staleTime: 30_000,
  });
}
